import { render, staticRenderFns } from "./order_link_poup_placard.vue?vue&type=template&id=3affcb67&scoped=true"
import script from "./order_link_poup_placard.vue?vue&type=script&lang=js"
export * from "./order_link_poup_placard.vue?vue&type=script&lang=js"
import style0 from "./order_link_poup_placard.vue?vue&type=style&index=0&id=3affcb67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3affcb67",
  null
  
)

export default component.exports